import { useContext } from 'react';
import { ReleaseDetailPageContext } from './ReleaseDetailPageContext';

export const useReleaseDetailPageContext = () =>
  useContext(ReleaseDetailPageContext);
